import { render, staticRenderFns } from "./PlaylistItemIcon.vue?vue&type=template&id=4a4f7ed6"
import script from "./PlaylistItemIcon.vue?vue&type=script&lang=js"
export * from "./PlaylistItemIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a4f7ed6')) {
      api.createRecord('4a4f7ed6', component.options)
    } else {
      api.reload('4a4f7ed6', component.options)
    }
    module.hot.accept("./PlaylistItemIcon.vue?vue&type=template&id=4a4f7ed6", function () {
      api.rerender('4a4f7ed6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/screens/PlaylistItemIcon.vue"
export default component.exports